import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { apiFetch } from '../utils/api';
const NotificationContext = createContext(null);
export function NotificationProvider({ children }) {
    const [notifications, setNotifications] = useState([]);
    const fetchNotifications = useCallback(async () => {
        try {
            const data = await apiFetch('/api/notifications');
            setNotifications(data.notifications);
        }
        catch {
            // Silently fail — notifications are non-critical
        }
    }, []);
    useEffect(() => {
        fetchNotifications();
        const interval = setInterval(fetchNotifications, 30000);
        return () => clearInterval(interval);
    }, [fetchNotifications]);
    const unreadCount = useMemo(() => notifications.filter(n => !n.read).length, [notifications]);
    const markRead = useCallback(async (id) => {
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
        try {
            await apiFetch(`/api/notifications/${id}/read`, { method: 'PUT' });
        }
        catch { }
    }, []);
    const markAllRead = useCallback(async () => {
        setNotifications(prev => prev.map(n => ({ ...n, read: true })));
        try {
            await apiFetch('/api/notifications/read-all', { method: 'PUT' });
        }
        catch { }
    }, []);
    const value = useMemo(() => ({ notifications, unreadCount, markRead, markAllRead, refresh: fetchNotifications }), [notifications, unreadCount, markRead, markAllRead, fetchNotifications]);
    return _jsx(NotificationContext.Provider, { value: value, children: children });
}
export function useNotifications() {
    const ctx = useContext(NotificationContext);
    if (!ctx)
        throw new Error('useNotifications must be used within NotificationProvider');
    return ctx;
}
